const ArrowRightIcon = ({ fill = '#00CF83', width = '16', height = '16' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1457_12214"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.00012207" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1457_12214)">
        <path
          d="M6.26683 12.0001L5.3335 11.0668L8.40016 8.00012L5.3335 4.93346L6.26683 4.00012L10.2668 8.00012L6.26683 12.0001Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default ArrowRightIcon
